import RootLayout from "../components/admin/RootLayout";
import AllPurchases from "../components/admin/AllPurchases";

const AllPurchasesPage = () => (
  <RootLayout>
    <AllPurchases />
  </RootLayout>
);

export default AllPurchasesPage;
